<template>
  <div>
    <Header></Header>
    <div class="row container mx-auto mt-4">
        <div class="col-lg-8 mb-4">
            <AddPost/>
            <Posts/>
        </div>
        <div class="col-lg-4 info-tab">
            <Info/>
        </div>
    </div>
  </div>
</template>

<script>
    import axios from 'axios'
    import { mapState } from 'vuex'
    import Header from '../header.vue'
    import AddPost from './addPost.vue'
    import Posts from './posts.vue'
    import Info from './infoCard.vue'

    export default {
        name: "Timeline",
        components: {
            Header,
            AddPost,
            Posts,
            Info
        },

        data () {
            return {
                
            }
        },

        computed:{
            ...mapState([
                'baseUrl'
            ]),
        },

        created() {
            
        },

        methods: {

        }
    }
</script>

<style>

    .info-tab {
        background: #FFFFFF;
        min-height: 91vh;
        max-width: 350px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        padding: 0;
    }

    
</style>